/**
 * Хранение реферального кода до регистрации (§40.3).
 *
 * Между переходом по ссылке и регистрацией могут пройти дни: человек открыл
 * лендинг, ушёл, вернулся. Поэтому код живёт локально, а не в текущем URL.
 * Срок ограничен: код полугодовой давности приписывать приглашению нечестно.
 */
const KEY = 'alterium.ref';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

interface StoredCode {
  code: string;
  savedAt: number;
}

export function saveReferralCode(code: string): void {
  const cleaned = code.trim().toUpperCase().replace(/[^0-9A-Z]/g, '').slice(0, 32);
  if (!cleaned) return;

  try {
    localStorage.setItem(KEY, JSON.stringify({ code: cleaned, savedAt: Date.now() }));
  } catch {
    // Приватный режим или переполненное хранилище: без кода регистрация
    // всё равно должна пройти.
  }
}

export function readReferralCode(): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;

    // Раньше код хранился строкой — старое значение читаем как есть.
    if (!raw.startsWith('{')) return raw;

    const stored = JSON.parse(raw) as StoredCode;
    if (!stored.code || Date.now() - stored.savedAt > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return stored.code;
  } catch {
    return null;
  }
}

export function clearReferralCode(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // см. выше
  }
}
